import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Overview } from "@/components/landing/Overview";
import { Suites } from "@/components/landing/Suites";
import { Dining } from "@/components/landing/Dining";
import { Testimonial } from "@/components/landing/Testimonial";
import { Booking } from "@/components/landing/Booking";
import { Footer } from "@/components/landing/Footer";

const LandingPage = () => (
  <div
    data-testid="landing-page"
    className="bg-[#F7F6F2] text-[#1A1A18] font-grotesk antialiased min-h-screen"
  >
    <Nav />
    <Hero />
    <Marquee />
    <Overview />
    <Suites />
    <Testimonial />
    <Booking />
    <Dining />
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
